import { EMAIL_ALERT } from "../actions";

export const emailAlertData = (state = {}, action) => {
  if (action.type == EMAIL_ALERT) return action.payload;
  return state;
};
